<div id="academy-course" class="page-layout simple left-sidebar inner-scroll">

    <!-- CENTER -->
    <div class="center">

        <!-- CONTENT -->
        <div id="course-content" class="content">
            <!-- ------contenido------ -->
            <div class="page-layout carded fullwidth inner-scroll cursoStep">
                <!-- TOP BACKGROUND -->
                <div class="top-bg"></div>
                <!-- CENTER -->
                <div class="center">
                    <!-- CONTENT HEADER -->
                    <div class="header p-24" fxLayout="row" fxLayoutAlign="start center">
                        <h2 class="m-0">{{'WIZARD.CT_INFORMACION.LISTA.TITULO' | translate}}</h2>
                    </div>
                    <!-- CONTENT CARD -->
                    <div class="content-card" [@animate]="{value:'*',params:{delay:'100ms', y:'25px'}}">
                        <!-- CONTENT TOOLBAR -->
                        <div class="toolbar primary px-24 py-8">
                            <span>{{'WIZARD.CT_INFORMACION.LISTA.SUBTI' | translate}}</span>
                        </div>
                        <!-- CONTENT -->
                        <div class="content" fusePerfectScrollbar>

                            <div class="course-step-content p-20">

                                <ng-container *ngIf="cargando">
                                    <div fxLayout="column" fxLayoutAlign="space-between center">
                                        <mat-spinner *ngIf="false"></mat-spinner><div class="spinnerCGO"></div>
                                        <h1>{{'WIZARD.CT_INFORMACION.LISTA.CARGANDO' | translate}}</h1>
                                    </div>
                                </ng-container>

                                <ng-container *ngIf="!cargando">

                                    <ng-container *ngIf="centrosTrabajo" [@animate]="{value:'*',params:{delay:'200ms', y:'125px'}}">
                                        <mat-accordion>
                                            <ng-container *ngIf="centrosTrabajo.centros.length == 0" [@animate]="{value:'*',params:{delay:'200ms', y:'125px'}}">
                                                <div class="statusDiv" fxLayout="row" fxLayoutAlign="center stretch" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
                                                    <div class="roundEdg warn mat-elevation-z4 pr-20 pl-20" fxLayout="row" fxLayoutAlign="space-between center">
                                                        <h2>{{'WIZARD.CT_INFORMACION.LISTA.NOCENTROS' | translate}}</h2>
                                                        <mat-icon class="ml-20 s-40">error_outline</mat-icon>
                                                    </div>
                                                </div>
                                            </ng-container>

                                            <mat-expansion-panel class="mb-20" *ngFor="let centro of centrosTrabajo.centros; let i = index;">
                                                <mat-expansion-panel-header class="accent-50">
                                                    <mat-panel-title class="tituloCT word">
                                                        {{centro.centro.nombre_CT}}
                                                    </mat-panel-title>
                                                    <mat-panel-description class="subtituloCT word">
                                                        {{'WIZARD.CT_INFORMACION.LISTA.CENTRO.MOREINFO' | translate}}
                                                    </mat-panel-description>
                                                </mat-expansion-panel-header>

                                                <div fxLayout="row" fxLayoutAlign="center stretch">
                                                    <div class="p-20" fxFlex="100" fxLayout="column" fxLayoutAlign="space-between stretch">
                                                        <h2 class="mt-0">{{'WIZARD.CT_INFORMACION.LISTA.CENTRO.TITULO' | translate}}</h2>
                                                        <mat-divider></mat-divider>
                                                        <div class="mt-20 mb-20">
                                                            <div class="h4 secondary-text">{{'WIZARD.CT_INFORMACION.LISTA.CENTRO.NOMBRE' | translate}}</div>
                                                            <div class="font-size-24 font-weight-300 line-height-1 mt-8">{{centro.centro.nombre_CT}}</div>
                                                        </div>
                                                        <mat-divider></mat-divider>
                                                        <div fxLayout="row" fxLayoutAlign="space-between stretch">
                                                            <div class="mt-20 mb-20" fxFlex="50">
                                                                <div class="h4 secondary-text word">{{'WIZARD.CT_INFORMACION.LISTA.CENTRO.ACTIVIDAD' | translate}}</div>
                                                                <div class="font-size-20 font-weight-300 line-height-1 mt-8 CT_nameAct word">{{centro.centro.actividad_principal_CT}}</div>
                                                            </div>
                                                            <div class="mt-20 mb-20" fxLayout="column" fxLayoutAlign="start stretch" fxFlex="50">
                                                                <div class="h4 secondary-text">{{'WIZARD.CT_INFORMACION.LISTA.CENTRO.RESPO' | translate}}</div>
                                                                <div class="font-size-20 font-weight-300 line-height-1 mt-8 CT_nameAct word">{{centro.centro.nombre_responsable_CT}}</div>
                                                                <div class="h4 secondary-text mt-20">{{'WIZARD.CT_INFORMACION.LISTA.CENTRO.EMAIL' | translate}}</div>
                                                                <div class="font-size-20 font-weight-300 line-height-1 mt-8 CT_email word">{{centro.centro.email_responsable_CT}}</div>
                                                                <div class="h4 secondary-text mt-20" *ngIf="centro.centro.email_razon_social">{{'WIZARD.CT_INFORMACION.LISTA.CENTRO.EMAILRS' | translate}}</div>
                                                                <div class="font-size-20 font-weight-300 line-height-1 mt-8" *ngIf="centro.centro.email_razon_social">{{centro.centro.email_razon_social}}</div>

                                                            </div>
                                                        </div>
                                                        <mat-divider></mat-divider>
                                                        <div class="mt-20 mb-20">
                                                            <div class="h4 secondary-text">{{'WIZARD.CT_INFORMACION.LISTA.CENTRO.DOMI' | translate}}</div>
                                                            <div class="font-size-20 font-weight-300 line-height-1 mt-8">{{centro.centro.domicilio_CT}}</div>
                                                        </div>
                                                        <div class="mt-20 mb-20">
                                                            <div class="h4 secondary-text">{{'WIZARD.CT_INFORMACION.LISTA.CENTRO.CTADV' | translate}}</div>
                                                            <div class="font-size-20 font-weight-300 line-height-1 mt-8">
                                                                <mat-progress-bar mode="determinate" value="{{porcentajeCT[i]}}" style="height: 20px;"></mat-progress-bar>
                                                                <h3>{{porcentajeCT[i] }}%</h3>
                                                            </div>
                                                        </div>
                                                        <mat-divider></mat-divider>
                                                        <div class="mt-20 h2 secondary-text">{{'WIZARD.CT_INFORMACION.LISTA.CENTRO.ACCIONES' | translate}}</div>
                                                        <div class="mt-20" fxLayout="row" fxLayoutAlign="center stretch">
                                                            <button mat-raised-button class="primary CT_BTN word" (click)="autologin(centro.user.user,centro.user.password)">
                                                              {{'WIZARD.CT_INFORMACION.LISTA.CENTRO.AUTOLOGIN' | translate}}
                                                            </button>
                                                        </div>
                                                        <div class="mt-20" fxLayout="row" fxLayoutAlign="center stretch">
                                                            <button mat-raised-button class="primary CT_BTN word" (click)="getEnterpriseDetail(i,centro.user.empresaId,centro.centro.nombre_CT);">
                                                                {{'WIZARD.CT_INFORMACION.LISTA.CENTRO.PDF' | translate}}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </mat-expansion-panel>

                                        </mat-accordion>
                                    </ng-container>
                                </ng-container>



                            </div>

                        </div>

                    </div>
                </div>
            </div>
            <!-- ------contenido------ -->
        </div>
        <!-- / CONTENT -->

    </div>
    <!-- / CENTER -->

</div>